<div class="card">

  <!-- Cabeçalho -->
  <div class="flex align-items-center justify-content-between mb-4 flex-wrap gap-2">
    <div class="flex align-items-center gap-2">
      <p-button
        icon="pi pi-arrow-left"
        styleClass="p-button-text p-button-secondary"
        pTooltip="Voltar"
        (onClick)="voltar()">
      </p-button>
      <app-header
        [titulo]="'Registro #' + registroId"
        [descricao]="tipo === 'visualizacao' ? 'Detalhes do registro de visualização (transformado).' : 'Detalhes completos do payload recebido e histórico de processamento.'">
      </app-header>
    </div>
    <app-status-badge *ngIf="registro" [status]="registro.status || registro.statusIntegracao"></app-status-badge>
  </div>

  <!-- Loading: skeleton -->
  <div *ngIf="loading">
    <div class="info-strip flex flex-wrap gap-3 mb-4">
      <p-skeleton width="5rem" height="2.5rem"></p-skeleton>
      <p-skeleton width="9rem" height="2.5rem"></p-skeleton>
      <p-skeleton width="7rem" height="2.5rem"></p-skeleton>
      <p-skeleton width="6rem" height="2.5rem"></p-skeleton>
      <p-skeleton width="11rem" height="2.5rem" styleClass="flex-1"></p-skeleton>
    </div>
    <div class="grid">
      <div class="col-12 md:col-6">
        <p-card>
          <ng-template pTemplate="header">
            <div class="p-3 border-bottom-1 surface-border">
              <p-skeleton width="8rem" height="1rem"></p-skeleton>
            </div>
          </ng-template>
          <p-skeleton width="100%" height=".8rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="85%"  height=".8rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="90%"  height=".8rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="70%"  height=".8rem"></p-skeleton>
        </p-card>
      </div>
      <div class="col-12 md:col-6">
        <p-card>
          <ng-template pTemplate="header">
            <div class="p-3 border-bottom-1 surface-border">
              <p-skeleton width="10rem" height="1rem"></p-skeleton>
            </div>
          </ng-template>
          <p-skeleton width="100%" height=".8rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="75%"  height=".8rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="88%"  height=".8rem"></p-skeleton>
        </p-card>
      </div>
    </div>
  </div>

  <!-- Conteúdo -->
  <div *ngIf="!loading && registro">

    <!-- Info strip -->
    <div class="info-strip flex flex-wrap gap-3 align-items-center mb-4 p-3 border-1 surface-border border-round surface-50">
      <div class="info-chip">
        <span class="info-lbl">ID</span>
        <span class="info-val">#{{ registro.id }}</span>
      </div>
      <div class="info-divider"></div>
      <div class="info-chip">
        <span class="info-lbl">Data {{ tipo === 'visualizacao' ? 'Criação' : 'Recebimento' }}</span>
        <span class="info-val">{{ registro.dataRecebimento | date:'dd/MM/yyyy HH:mm:ss' }}</span>
      </div>
      <div class="info-divider"></div>
      <div class="info-chip">
        <span class="info-lbl">IP Origem</span>
        <span class="info-val">{{ registro.ipOrigem }}</span>
      </div>
      <div *ngIf="registro.tempoProcessamentoMs" class="info-divider"></div>
      <div *ngIf="registro.tempoProcessamentoMs" class="info-chip">
        <span class="info-lbl">Tempo Processamento</span>
        <span class="info-val">
          <i class="pi pi-clock text-500 text-xs"></i>
          {{ registro.tempoProcessamentoMs / 1000 | number:'1.1-2' }}s
        </span>
      </div>
      <div *ngIf="registro.tentativasProcessamento" class="info-divider"></div>
      <div *ngIf="registro.tentativasProcessamento" class="info-chip">
        <span class="info-lbl">Tentativas</span>
        <span class="info-val" [class.text-red-600]="registro.tentativasProcessamento > 1">
          {{ registro.tentativasProcessamento }}
        </span>
      </div>
      <div *ngIf="tipo === 'visualizacao' && registro.mapeamentoNome" class="info-divider"></div>
      <div *ngIf="tipo === 'visualizacao' && registro.mapeamentoNome" class="info-chip">
        <span class="info-lbl">Mapeamento</span>
        <span class="info-val">
          <i class="pi pi-sitemap text-500 text-xs"></i>
          {{ registro.mapeamentoNome }}
        </span>
      </div>
      <div *ngIf="registro.hashPayload && registro.hashPayload !== '-'" class="info-divider"></div>
      <div *ngIf="registro.hashPayload && registro.hashPayload !== '-'" class="info-chip info-chip-grow">
        <span class="info-lbl">Hash</span>
        <span class="info-val info-hash" [pTooltip]="registro.hashPayload" tooltipPosition="top">
          {{ registro.hashPayload }}
          <p-button
            icon="pi pi-copy"
            styleClass="p-button-text p-button-secondary p-button-sm hash-copy-btn"
            (onClick)="copiarTexto(registro.hashPayload)">
          </p-button>
        </span>
      </div>
    </div>

    <!-- Banner de mensagem (sucesso/info) -->
    <div *ngIf="registro.mensagem && !registro.erroMensagem"
      class="flex align-items-center gap-2 mb-3 p-3 border-round border-1 border-green-200"
      style="background:#f0fdf4">
      <i class="pi pi-check-circle text-green-500"></i>
      <span class="text-green-700 font-medium text-sm">{{ registro.mensagem }}</span>
    </div>

    <!-- Banner de erro -->
    <div *ngIf="registro.erroMensagem" class="error-banner mb-3 border-round border-1 border-red-200 p-3">
      <div class="flex align-items-center gap-2 mb-2">
        <i class="pi pi-exclamation-triangle text-red-500"></i>
        <span class="font-bold text-red-600 text-sm">{{ registro.erroMensagem }}</span>
      </div>
      <pre *ngIf="registro.erroStackTrace"
        class="surface-ground border-round p-3 overflow-auto text-xs mt-2 m-0"
        style="max-height:140px;font-family:monospace;color:#374151">{{ registro.erroStackTrace }}</pre>
    </div>

    <!-- Payloads -->
    <div class="grid">

      <!-- Payload Original / Dados de Entrada -->
      <div class="col-12 md:col-6">
        <p-card styleClass="h-full">
          <ng-template pTemplate="header">
            <div class="p-3 border-bottom-1 surface-border flex justify-content-between align-items-center">
              <span class="text-900 font-semibold text-sm">
                <i class="pi pi-download text-500 mr-1"></i>
                {{ tipo === 'visualizacao' ? 'Dados de Entrada' : 'Payload Original' }}
              </span>
              <p-button
                icon="pi pi-copy"
                styleClass="p-button-rounded p-button-text p-button-sm p-button-secondary"
                pTooltip="Copiar JSON"
                (onClick)="copiarPayload(registro.payloadOriginal)">
              </p-button>
            </div>
          </ng-template>
          <pre class="json-pre m-0">{{ formatarJson(registro.payloadOriginal) }}</pre>
        </p-card>
      </div>

      <!-- Dados Transformados -->
      <div class="col-12 md:col-6">
        <p-card styleClass="h-full">
          <ng-template pTemplate="header">
            <div class="p-3 border-bottom-1 surface-border flex justify-content-between align-items-center">
              <span class="text-900 font-semibold text-sm">
                <i class="pi pi-sliders-h text-500 mr-1"></i>
                Dados Transformados
              </span>
              <p-button
                icon="pi pi-copy"
                styleClass="p-button-rounded p-button-text p-button-sm p-button-secondary"
                pTooltip="Copiar JSON"
                [disabled]="!registro.dadosProcessados"
                (onClick)="copiarPayload(registro.dadosProcessados)">
              </p-button>
            </div>
          </ng-template>
          <div *ngIf="!registro.dadosProcessados" class="flex flex-column align-items-center justify-content-center p-5 text-500">
            <i class="pi pi-ban text-3xl mb-2 text-300"></i>
            <span class="text-sm">{{ registro.erroMensagem ? 'Transformação não concluída devido ao erro.' : 'Nenhum dado transformado disponível.' }}</span>
          </div>
          <pre *ngIf="registro.dadosProcessados" class="json-pre m-0">{{ formatarJson(registro.dadosProcessados) }}</pre>
        </p-card>
      </div>

    </div>

    <!-- Timeline -->
    <div *ngIf="registro.timeline && registro.timeline.length > 0" class="mt-3">
      <p-panel [toggleable]="true" [collapsed]="false">
        <ng-template pTemplate="header">
          <span class="font-semibold text-900 text-sm">
            <i class="pi pi-history mr-2"></i>
            Timeline de Processamento
            <span class="ml-2 px-2 py-1 border-round text-xs font-bold"
              style="background:#dbeafe;color:#1d4ed8">
              {{ registro.timeline.length }} eventos
            </span>
          </span>
        </ng-template>
        <app-timeline-rastreio [eventos]="registro.timeline"></app-timeline-rastreio>
      </p-panel>
    </div>

    <!-- Headers HTTP -->
    <div *ngIf="registro.headers && hasHeaders(registro.headers)" class="mt-3">
      <p-panel [toggleable]="true" [collapsed]="true">
        <ng-template pTemplate="header">
          <span class="font-semibold text-900 text-sm">
            <i class="pi pi-code mr-2"></i>
            Headers HTTP
          </span>
        </ng-template>
        <p-table [value]="registro.headers | keyvalue" styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
            <tr>
              <th style="width:35%">Header</th>
              <th>Valor</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-header>
            <tr>
              <td><code class="font-bold text-purple-700">{{ header.key }}</code></td>
              <td class="text-600">{{ header.value }}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>

  </div>
</div>
